export const fieldsAtencion = `
  id
  token
  fechaCreacion
  estadoRev
  signature
  semiologia
  comentarioValidacion
  urlConsentimiento
  tipoVisita{ 
    id
    descripcion 
  }
  tipoEspecialidad{ descripcion }
  tipoConsulta{ descripcion, id }

  derivacionesSet {
    id
    tipoAtencion
    estado
    especialidad {
      descripcion
      id
      codEsp
    }
  }
  interconsultasSet {
    id
    especialidad {
      descripcion
      id
      codEsp
    }
  }
    
  descansomedicoSet {
        id
        actividadlab
        aislamiento
        contingencia
        diasdescanso
        estado
        direccion
        empresa
        observacion
        tipodiagnostico {
          descripcion
          id
        }
        residencia {
          id
        }
      }
  estudiolabSet {
        id  
        fechaCreacion
        fechaProgramada
        modalidad {
          descripcion
          id
        }
        LabAs400 {
          id
          estado
          categoriaOrion
          estadoLab400
          estadoOrion
          fechaOrdenOrion
          fechaResultado: fechaResultados
          idslaboratorios
          numeroOrden
        }
        LabAux {
          id
          laboratorios
        }
      }
    envioimagenSet {
      token
      estado
      imagen {
        id
        nombre
        codigo
        tipoImagen {
          descripcion
          id
        }
      }
      lateralidad {
        descripcion
        id
      }
      sedacion
      numeroOrdenAs400
      motivoSolicitud
      resumenClinico
      alertaIgnorada
    }
    recetaSet {
    token
    id
    alergias
      estadoTransitorio
      fecha
      medicamentosRecetados {
      token
      id
        dosis
        duracion
        frecuencia
        observacion
        estadoTransitorio
        estado
        cantidad
        medicamento {
          codigo
          id
          nombre
          presentacion
        }
        alertaIgnorada
      }
    }
    anamnesisSet {
      id
      obsadicionalAp
      obsadicionalEf
      obsadicionalAf
      motivoConsulta
      obsadicionalRo
      problemaActual
      ptratamiento
    }
        revorganamSet {
        id
      descripcionGeneral
      estado
      revisionorganos {
      id
        descripcion
      }
    }
        exafisanamSet {
        id
        estado
      descripcionGeneral
      examenfisico {
      id

        descripcion
        tipoExamen
      }
    }

      antefamanamSet {
      id
      estado
      descripcionGeneral
      familiar
      antescedentesFamiliares {
        descripcion
        id
      }
    }
  anteperanamSet {
      descripcionGeneral
      id
      estado
      antescedentesPersonales {
        descripcion
        id
        tipoAntecedente
      }
      anio
    }
    
  catmed{
    id
    descripcion
    precio
  }
  cita{
    id
    token
    cobSeleccionada{ id, descripcion }
    documentoscitaSet {
      urlsDocAs400
      fechaCreacion
    }
    detallescitaSet {
      id
      detailsSeguro
      detallesTitulares
    }
    codderivacion
    derivacion
    urlDerivacion
    urlCodigoDer
    fechaCita
    horaCita
    establecimiento{ Descripcion, id }
    paciente {
    id
      numHistoriaClinica
      persona {
        residencia{
        id
        callePrincipal
        }
        identificacion
        primerNombre
        segundoNombre
        primerApellido
        segundoApellido
        fechaNacimiento
        ocupacion {
        id
        descripcion
        }
      }
    }
    doctor{
      id
      idPersona{
        primerNombre
        segundoNombre
        primerApellido
        segundoApellido
      }
      especialidad{
        descripcion
        codEsp
      }
    }
  }

  diaganamSet {
  id
  estado
    diagnostico {
    id
      descripcion
      codigo
    }
    esprincipal
    tipoDiagnostico {
    id
      descripcion
    }
    estado
  }

  comentariovalidacionatencionSet {
    id
    token
    estadoComentario
    usuarioCreador {
      id
      username
    }
  }
`;
